<template>
  <div class="community-categories-list my-n3">
    <router-link
      :to="{ name: 'community' }"
      class="text-light"
      :class="{ active: isActive(null) }"
    >
      <i class="fas fa-home"></i> Página inicial
    </router-link>

    <router-link
      v-for="category in categories"
      :key="category.id"
      :to="{ name: 'community', query: { category: category.id } }"
      class="text-light"
      :class="{ active: isActive(category) }"
    >
      <img :src="category.photo" />
      {{ category.name }}
    </router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("courses", ["categories"])
  },
  methods: {
    isActive(category) {
      if (this.$route.name !== "community") return false;
      if (!this.$route.query.category && !category) return true;
      if (category && parseInt(this.$route.query.category) === category.id)
        return true;
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.community-categories-list {
  a {
    text-decoration: none;
    display: block;
    font-size: 14px;
    border-radius: 30px;
    margin: 8px 0;
    padding: 8px 16px;

    &:hover,
    &.active {
      background: #232323;
    }

    img,
    i {
      height: auto;
      width: 12px;
      margin-right: 4px;
    }
  }
}
</style>
